module.exports = __webpack_public_path__ + "img/coupon-QR.11a52cac.png";